export default __webpack_public_path__ + "static/media/ic-unattempted.7af62118.svg";